import React from 'react'

export default function ErrorPage() {
  return (
    <div><h1>Some Error Occured</h1></div>
  )
}
